// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__N0KQ4","title":"styles_title__1fWBj"};